<template>
  <div
    v-if="$store.getters.isLoggedIn"
    id="customer-form-page"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      :width="drawerWidth"
      mobile-break-point="1024"
      floating
      app>
      <div class="page-logo-container mx-auto my-5">
        <PosmLogo />
      </div>

      <v-spacer></v-spacer>

      <!-- User Account Menu -->
      <UserMenu class="mt-auto" />
      <!-- User Account Menu -->
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- Customer Form Page Content -->
    <v-content>
      <v-toolbar>
        <v-app-bar-nav-icon
          class="page-drawer-toggle mr-0"
          @click="isDrawerOpen = !isDrawerOpen">
        </v-app-bar-nav-icon>

        <v-toolbar-title
          class="pl-0">
          <MainNavigationMenu />
        </v-toolbar-title>
      </v-toolbar>

      <!-- Customer Form -->
      <CustomerForm
        class="page-content mx-5"
      />
      <!-- / Customer Form -->
    </v-content>
    <!-- / Customer Form Page Content -->
  </div>
</template>

<script>
import PosmLogo from '../components/PosmLogo.vue';
import MainNavigationMenu from '../components/MainNavigationMenu.vue';
import UserMenu from '../components/UserMenu.vue';
import CustomerForm from '../components/CustomerForm.vue';

export default {
  name: 'CustomerFormPage',
  components: {
    PosmLogo,
    MainNavigationMenu,
    UserMenu,
    CustomerForm,
  },
};
</script>

<style lang="scss"></style>
